import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { LoginComponent } from './pages/login/login.component';
import { ImpactStoriesComponent } from './pages/impact-stories/impact-stories.component';
import { ResourcesComponent } from './pages/resources/resources.component';
import { RelatedStoriesComponent } from './pages/related-stories/related-stories.component';
import { ManagePortalComponent } from './admin/manage-portal/manage-portal.component';
import { SubscribersComponent } from './admin/subscribers/subscribers.component';
import { ResourcesViewComponent } from './pages/resources-view/resources-view.component';
import { AuthGuard } from './auth.guard';
import { OurpartnersComponent } from './pages/ourpartners/ourpartners.component';
import { SignUpComponent } from './pages/sign-up/sign-up.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { CommunicationsComponent } from './admin/communications/communications.component';
import { UserProfileComponent } from './admin/user-profile/user-profile.component';
import { NotificationsComponent } from './admin/notifications/notifications.component';
import { ManageUserComponent } from './admin/user-management/manage-user/manage-user.component';
import { UserLevelComponent } from './admin/user-management/user-level/user-level.component';
import { AddUserComponent } from './admin/user-management/add-user/add-user.component';
import { UserPoliciesComponent } from './admin/user-management/user-policies/user-policies.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { FormBuilderComponent } from './pages/form-builder/form-builder.component';
import { IpsaFormsComponent } from './pages/ipsa-forms/ipsa-forms.component';
import { FormListComponent } from './pages/ipsa-forms/form-list/form-list.component';
import { IpsaFormDesignComponent } from './pages/ipsa-forms/ipsa-form-design/ipsa-form-design.component';
import { IpsaDashboardComponent } from './pages/ipsa-dashboard/ipsa-dashboard.component';
import { IpsaIntroComponent } from './pages/ipsa-intro/ipsa-intro.component';
import { IpsaComponent } from './pages/ipsa-forms/ipsa/ipsa.component';
import { IpsaReportComponent } from './pages/ipsa-forms/ipsa-report/ipsa-report.component';
import { ApprovalRequestComponent } from './admin/approval-request/approval-request.component';


const routes: Routes = [

  {
    path: 'home',
        component: HomeComponent,
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'about-us',
    component: AboutUsComponent
  },
  {
    path: 'communications',
    component: CommunicationsComponent
  },
  {
    path: 'user-profile',
    component: UserProfileComponent
  },
  {
    path: 'notifications',
    component: NotificationsComponent
  },
  {
    path: 'resources',
    component: ResourcesComponent
  },
  {
    path: 'resources-view',
    component: ResourcesViewComponent
  },
  {
    path: 'impact-stories',
    component: ImpactStoriesComponent
  },
  {
    path: 'about-us',
    component: AboutUsComponent
  },
  {
    path: 'related-stories',
    component: RelatedStoriesComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'reset-password/:id',
    component: ResetPasswordComponent
  },
  {
    path: 'sign-up',
    component: SignUpComponent
  },
  {
    path: 'ourpartners',
    component: OurpartnersComponent
  },
  {
    path: 'manage-portal',
    canActivate: [AuthGuard],
    component: ManagePortalComponent
  },
  {
    path: 'prism-report',
    component: IpsaReportComponent
  },
  {
    path: 'prism',
    component: IpsaComponent
  },
  {
    path: 'prism-forms',
    component: IpsaFormsComponent
  },
  {
    path: 'prism-forms-list',
    component: FormListComponent
  },
  {
    path: 'prism-forms-design',
    component: IpsaFormDesignComponent
  },
  {
    path: 'prism-dashboard',
    component: IpsaDashboardComponent
  },
  {
    path: 'prism-intro',
    component: IpsaIntroComponent
  },
  {
    path: 'subscribers',
    canActivate: [AuthGuard],
    component: SubscribersComponent
  },
  {
    path: 'form-builder',
    component: FormBuilderComponent
  },
  {
    path: 'manage-user',
    component: ManageUserComponent
  },
  {
    path: 'approval-request',
    component: ApprovalRequestComponent
  },
  {
    path: 'user-level',
    component: UserLevelComponent
  },
  {
    path: 'add-user',
    canActivate: [AuthGuard],
    component: AddUserComponent
  },
  {
    path: 'user-policies',
    canActivate: [AuthGuard],
    component: UserPoliciesComponent
  },
  {
    path: 'user-policies/:id',
    canActivate: [AuthGuard],
    component: UserPoliciesComponent
  },
  {
    path: 'add-user/:id',
    canActivate: [AuthGuard],
    component: AddUserComponent

  },
  {
    path: '',
    loadChildren: () => import('./admin/manage-portal/manage-portal.module').then(m => m.ManagePortalModule),
  },
  {
    path: '**',
    redirectTo: '/'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
